module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-Medium-6e976150c457a5edc1f31e3c6affe0c5.woff2";